import { BrowserRouter as Router } from "react-router-dom";
import { useEffect } from "react";
import { AppProviders } from "./components/providers/AppProviders";
import { Navigation } from "./components/Navigation";
import { AppRoutes } from "./components/routing/AppRoutes";
import { ScrollToTop } from "./components/routing/ScrollToTop";
import { TrialComponents } from "./components/trial/TrialComponents";
import { useToast } from "./hooks/use-toast";
import { getTrialStatus } from "./utils/trialUtils";

function App() {
  const { toast } = useToast();

  useEffect(() => {
    const status = getTrialStatus();
    if (status.isActive && status.daysRemaining <= 3) {
      toast({
        title: "Trial Ending Soon",
        description: `Your trial will expire in ${status.daysRemaining} days. Upgrade now to keep access to all features.`,
        duration: 7000,
      });
    }
  }, [toast]);

  return (
    <Router>
      <AppProviders>
        <ScrollToTop />
        <Navigation />
        <AppRoutes />
        <TrialComponents />
      </AppProviders>
    </Router>
  );
}

export default App;